import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { useSettings } from "../context/SettingsContext";
import { SITE_ASSETS } from "../mock";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/projects", label: "Projects" },
  { to: "/services", label: "Services" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { settings } = useSettings();
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 bg-[#F5EFE6] ${
        scrolled ? "shadow-md border-b border-[#E8DCC4]" : "border-b border-[#EBE0CE]/60"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3 group">
          <div className="w-12 h-12 rounded-full bg-white/95 flex items-center justify-center overflow-hidden ring-1 ring-[#B8893C]/40">
            <img src={SITE_ASSETS.logo} alt="Tamra" className="w-10 h-10 object-contain" />
          </div>
          <div className="leading-none">
            <div className="font-display text-[22px] tracking-[0.28em] text-[#5C2018]">{settings.brandName}</div>
            <div className="text-[10px] tracking-[0.42em] text-[#B8893C] mt-1">{settings.brandSubtitle}</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              className={`fancy-link text-[12px] tracking-[0.32em] uppercase transition-colors ${
                pathname === n.to ? "text-[#5C2018]" : "text-[#1F1B17] hover:text-[#5C2018]"
              }`}
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a href={`tel:${settings.contact.phone}`} className="group inline-flex items-center gap-3 px-5 py-3 border border-[#5C2018] text-[#5C2018] text-[12px] tracking-[0.25em] uppercase transition-all duration-400 hover:bg-[#5C2018] hover:text-[#F5EFE6]">
            <Phone size={14} className="transition-transform duration-500 group-hover:rotate-[12deg]" />
            <span className="font-medium">{settings.contact.phone.replace("+91 ", "")}</span>
          </a>
        </div>

        <button
          className="lg:hidden p-2 text-[#1F1B17]"
          onClick={() => setOpen((v) => !v)}
          aria-label="menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#F5EFE6] border-t border-[#EBE0CE]">
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className="text-[13px] tracking-[0.32em] uppercase text-[#1F1B17]"
              >
                {n.label}
              </Link>
            ))}
            <a href={`tel:${settings.contact.phone}`} className="btn-primary mt-2 w-fit">
              <Phone size={14} /> Call Us
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
